import axios from "axios";
import useAppState from "../state/app.state";
import useAuthState from "../state/auth.state";
import { slavt, slavtAuth, slavtCommunication } from "./config";

const slavtHTTP = axios.create({
  baseURL: slavt.url,
  timeout: slavt.timeout,
  headers: slavt.headers,
});

slavtHTTP.interceptors.request.use((config) => {
  config.headers["Accept-Language"] = useAppState.getState().language;
  config.headers["Authorization"] =
    `Bearer ${useAuthState.getState().user?.token}`;

  return config;
});

const slavtCommunicationHTTP = axios.create({
  baseURL: slavtCommunication.url,
  timeout: slavtCommunication.timeout,
  headers: slavtCommunication.headers,
});

slavtCommunicationHTTP.interceptors.request.use((config) => {
  config.headers["Accept-Language"] = useAppState.getState().language;
  config.headers["Authorization"] =
    `Bearer ${useAuthState.getState().user?.token}`;

  return config;
});

const slavtAuthHTTP = axios.create({
  baseURL: slavtAuth.url,
  timeout: slavtAuth.timeout,
  headers: slavtAuth.headers,
});

export { slavtAuthHTTP, slavtCommunicationHTTP, slavtHTTP };
